import PropTypes from 'prop-types';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
var ImageWrapper = styled.div.withConfig({
  displayName: "ImageWrapper",
  componentId: "pxe8mk-0"
})(["position:absolute;overflow:initial;width:100%;height:100%;top:0;left:", ";@media only screen and (max-width:", "px){position:static;direction:", ";padding-right:", "px;padding-left:", "px;}"], function (_ref) {
  var rightToLeft = _ref.rightToLeft;
  return rightToLeft ? '-50%' : '50%';
}, spacing.collapseMenuWidth, function (_ref2) {
  var rightToLeft = _ref2.rightToLeft;
  return rightToLeft ? 'rtl' : null;
}, spacing.base, spacing.base);
ImageWrapper.propTypes = {
  rightToLeft: PropTypes.bool
};
export default ImageWrapper;